(function () {
    'use strict';

    var offcanvasPanels = document.querySelectorAll('.offcanvas');
    if (!offcanvasPanels.length) return;

    var activePanel = null;

    function openOffcanvas(panel) {
        if (activePanel) closeOffcanvas(activePanel);
        activePanel = panel;
        panel.classList.add('active');
        if (window.apollonLenis) window.apollonLenis.stop();

        // Stagger form fields and surrounding elements
        gsap.fromTo(
            panel.querySelectorAll('.cf__field, .cf__gdpr, .cf__submit, .offcanvas__desc, .offcanvas__fallback'),
            { y: 20, opacity: 0 },
            {
                y: 0, opacity: 1,
                stagger: 0.06,
                duration: 0.5,
                delay: 0.3,
                ease: 'power3.out'
            }
        );
    }

    function closeOffcanvas(panel) {
        panel.classList.remove('active');
        activePanel = null;
        if (window.apollonLenis) window.apollonLenis.start();
        ScrollTrigger.refresh();
    }

    // Bind open buttons — data-offcanvas="invest" opens #offcanvas-invest
    document.querySelectorAll('.js-offcanvas-open').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            var target = btn.getAttribute('data-offcanvas') || 'invest';
            var panel = document.getElementById('offcanvas-' + target);
            if (panel) openOffcanvas(panel);
        });
    });

    // Backdrop click + close buttons — per panel
    offcanvasPanels.forEach(function (panel) {
        var backdrop = panel.querySelector('.offcanvas__backdrop');
        if (backdrop) {
            backdrop.addEventListener('click', function () { closeOffcanvas(panel); });
        }

        panel.querySelectorAll('.js-offcanvas-close').forEach(function (btn) {
            btn.addEventListener('click', function () { closeOffcanvas(panel); });
        });
    });

    // Escape key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && activePanel) {
            closeOffcanvas(activePanel);
        }
    });

    // Veřejné API — umožňuje programové otevření (např. auto-open po čase).
    window.apollonOffcanvas = {
        open: function (type) {
            var panel = document.getElementById('offcanvas-' + (type || 'contact'));
            if (panel) openOffcanvas(panel);
        },
        close: function () {
            if (activePanel) closeOffcanvas(activePanel);
        },
        isOpen: function () {
            return activePanel !== null;
        }
    };
})();
